module.exports = __webpack_public_path__ + "img/Seite26-default-papa.c7112213.png";